export default "//cdn.scentbird.com/assets/frontbird-site/images/timeBird_524c5b.png";